module.exports = __webpack_public_path__ + "img/1581320932.ff797353.jpg";